<wtf-dialogcontent [size]="'md'" [dialogTitle]="dialogTitle" (closeModal)="dialogRef.close()" [action]="action">
    <!-- Content -->

    <form name="grupoForm" [formGroup]="grupoForm" class="tax-type-form w-100-p p-20" fxLayout="column" fxFlex>
        <div fxLayout="row" fxLayoutAlign="end center">
            <mat-label>{{ "*Campos Obligatorios" | translate }}</mat-label>
        </div>
        <div class="labels" fxLayout="row" fxLayoutWrap fxShow.gt-sm *ngIf="action === recordAction.View">
            <div class="label" fxLayout="row" fxLayoutAlign="start center">
                <div class="label-color" [ngStyle]="{
                        'background-color':
                            grupoModel.status == 1 ? 'green' : 'red'
                    }"></div>
                <div class="label-title">{{"Activo" | translate}}</div>
            </div>
        </div>

        <div class="row gap-2">
            <div class="active-container" fxLayout="row" *ngIf="action !== recordAction.View">
                <mat-label>{{ "Activo" | translate }}</mat-label>
                <mat-slide-toggle name="isActive" formControlName="isActive" class="ml-24" aria-label="Active">
                </mat-slide-toggle>
            </div>

            <div class="active-container" fxLayout="row" *ngIf="action !== recordAction.View">
                <mat-label>{{ "borrarDuplicados" | translate }}</mat-label>
                <mat-slide-toggle name="deleteDuplicates" formControlName="deleteDuplicates" class="ml-24"
                    aria-label="Delete Duplicates">
                </mat-slide-toggle>
            </div>
        </div>

        <mat-label>{{ "Nombre del grupo" | translate }}*</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="name" formControlName="name" placeholder="" [readonly]="action === recordAction.View"
                required />
        </mat-form-field>
        @if (isControlValid(grupoForm, "name")) {
        <div class="text-danger ng-mt-2">
            {{ getErrorMessage(grupoForm, "name", "Nombre del grupo") }}
        </div>
        }
        <mat-label>{{ "Operadora" | translate }}*</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <mat-select name="operadora" formControlName="operadora" placeholder=""
                [disabled]="action === recordAction.View">
                <mat-option *ngFor="let operator of operators" [value]="operator.id">{{ operator.name }}</mat-option>
            </mat-select>
        </mat-form-field>

        <button *ngIf="action !== recordAction.Update" mat-raised-button (click)="performAction()" class="save-button"
            [disabled]="grupoForm.invalid" aria-label="GUARDAR">
            <span class="material-icons-outlined mr-20"> save </span>
            {{ "Guardar" | translate }}
        </button>

        <button *ngIf="action === recordAction.Update" mat-raised-button (click)="performAction()" class="save-button"
            [disabled]="grupoForm.invalid" aria-label="GUARDAR">
            <span class="material-icons-outlined mr-20"> save </span>
            {{ "Guardar" | translate }}
        </button>
    </form>
    <!-- Content -->

    <!-- Buttons -->

    <!-- Buttons -->
</wtf-dialogcontent>